<template>
  <div style="width:760px;height:100%;overflow: hidden;margin:0 auto;position: relative;">
    <iframe id="agpBox" name="agpBox" :src="agpHtmlUrl + '?source=demo'" style="border:0;width:100%;height:50px;background:#fff;padding:0 15px;box-sizing: border-box;border-radius:0 0 25px 25px;" v-if="toolbarShow"></iframe>
    <iframe id="plugBox" name="plugBox" :src="plugHtmlUrl" style="border:0;width:100%;height:500px;position:absolute;left:0;top:50px;z-index:9999;display:none;padding:0 15px;box-sizing: border-box;"></iframe>

    <el-dialog :title="Language('通讯录')" :visible.sync="linkBookShow" width="400px" :modal-append-to-body="false"
      custom-class="center-dialog setinfo-dialog" :close-on-press-escape="false" :close-on-click-modal="false" @close="closeLinkBookFn">
      <div class="pl-15 pr-15">
        <div class="transfer_item radio_tree">
          <el-radio-group v-model="checkPhone" class="w-100bf" v-if="linkBookOne">
            <el-tree ref="tree" :data="linkBookList" node-key="id">
              <div slot-scope="{data}">
                <span class="font-14" v-if="data.isType==1">{{data.label}}</span>
                <el-radio :label="data" v-else>{{data.label}}</el-radio>
              </div>
            </el-tree>
          </el-radio-group>
          <el-checkbox-group v-model="checkPhoneMore" class="w-100bf" v-else>
            <el-tree ref="tree" :data="linkBookList" node-key="id">
              <div slot-scope="{data}">
                <span class="font-14" v-if="data.isType==1">{{data.label}}</span>
                <el-checkbox :label="data" v-else>{{data.label}}</el-checkbox>
              </div>
            </el-tree>
          </el-checkbox-group>
        </div>
      </div>
      <div class="diglog-bom-box">
        <el-button type="primary" size="small" @click="setLinkBook">{{Language('确 定')}}</el-button>
        <el-button @click="closeLinkBookFn" size="small">{{Language('取 消')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="Language(agentDialogTitle)" :visible.sync="agentShow" width="800px" :modal-append-to-body="false"
      custom-class="center-dialog setinfo-dialog" :close-on-press-escape="false" :close-on-click-modal="false" @close="closeAgentFn">
      <div class="pl-15 pr-15 mb-15">
        <el-row :gutter="16">
          <el-col :span="8">
            <div class="mb-10">
              <el-input v-model="agentGroupKey" :placeholder="Language('坐席组名称')" size="small" clearable></el-input>
            </div>
            <div class="transfer_item mt-0">
              <el-table :data="agentGroupDataAll.filter(data => !agentGroupKey || data.groupName.includes(agentGroupKey))" border max-height="400px" highlight-current-row ref="groupTable" @row-click="groupRowClickFn">
                <el-table-column prop="groupName" :label="Language('坐席组名称')"></el-table-column>
              </el-table>
            </div>
          </el-col>
          <el-col :span="16">
            <div class="mb-10" style="width:50%;">
              <el-input v-model="agentKey" :placeholder="Language('工号或坐席名称')" size="small" clearable></el-input>
            </div>
            <div class="transfer_item mt-0">
              <el-table :data="showAgentData.filter(data => !agentKey || data.userName.includes(agentKey) || data.workNo.includes(agentKey))" border max-height="368px" highlight-current-row ref="agentTable" @row-click="agentRowClickFn" @row-dblclick="agentRowDbClickFn">
                <el-table-column prop="workNo" :label="Language('工号')"></el-table-column>
                <el-table-column prop="userName" :label="Language('坐席名称')"></el-table-column>
                <el-table-column prop="skillName" :label="Language('技能组名称')"></el-table-column>
                <el-table-column :label="Language('状态')">
                  <template slot-scope="scope">
                    <span style="color:#8b73ff;" v-if="scope.row.status == 64">{{Language('振铃')}}</span>
                    <span style="color:#409EFF;">{{Language('空闲')}}</span>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="diglog-bom-box">
        <el-button type="primary" size="small" @click="submitAgentFn">{{Language('确 定')}}</el-button>
        <el-button @click="agentShow = false" size="small">{{Language('取 消')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog title="IVR列表" :visible.sync="ivrShow" width="400px" :modal-append-to-body="false"
      custom-class="center-dialog setinfo-dialog" :close-on-press-escape="false" :close-on-click-modal="false" @close="closeIvrFn">
      <div class="pl-15 pr-15 pb-5">
        <el-table :data="ivrList" border highlight-current-row ref="ivrTable" @row-click="ivrRowClickFn">
          <el-table-column prop="name" :label="Language('IVR名称')"></el-table-column>
          <el-table-column prop="flowId" :label="Language('流程ID')"></el-table-column>
          <el-table-column prop="nodeId" :label="Language('节点ID')"></el-table-column>
        </el-table>
        <div style="text-align: center;">
          <el-pagination
            layout="total, prev, pager, next"
            :current-page.sync="ivrPage"
            :page-size="10"
            @current-change="getIvrListFn"
            :total="ivrTotal"
          >
          </el-pagination>
        </div>
      </div>
      <div class="diglog-bom-box">
        <el-button type="primary" size="small" @click="submitIvrFn">{{Language('确 定')}}</el-button>
        <el-button @click="ivrShow = false" size="small">{{Language('取 消')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog title="技能列表 (转移至技能)" :visible.sync="skillShow" width="400px" :modal-append-to-body="false"
      custom-class="center-dialog setinfo-dialog" :close-on-press-escape="false" :close-on-click-modal="false" @close="closeSkillFn">
      <div class="pl-15 pr-15 pb-5">
        <el-table :data="skillList" border highlight-current-row ref="skillTable" @row-click="skillRowClickFn">
          <el-table-column prop="groupName" :label="Language('坐席组')"></el-table-column>
          <el-table-column prop="skillName" :label="Language('技能')"></el-table-column>
        </el-table>
        <div style="text-align: center;">
          <el-pagination
            layout="total, prev, pager, next"
            :current-page.sync="skillPage"
            :page-size="10"
            @current-change="getGroupSkillListFn"
            :total="skillTotal"
          >
          </el-pagination>
        </div>
      </div>
      <div class="diglog-bom-box">
        <el-button type="primary" size="small" @click="submitSkillFn">{{Language('确 定')}}</el-button>
        <el-button @click="skillShow = false" size="small">{{Language('取 消')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog title="保持找回" :visible.sync="holdCallShow" width="800px" :modal-append-to-body="false"
      custom-class="center-dialog setinfo-dialog" :close-on-press-escape="false" :close-on-click-modal="false" @close="closeHoldCallFn">
      <div class="pl-15 pr-15 pb-5">
        <el-table :data="holdCallList" border highlight-current-row ref="holdCallTable" @row-click="holdCallRowClickFn">
          <el-table-column prop="CallOfferedType" :label="Language('呼叫类型')"></el-table-column>
          <el-table-column prop="Caller" :label="Language('客户号码')"></el-table-column>
          <el-table-column prop="Called" :label="Language('热线号码/工号')"></el-table-column>
          <el-table-column prop="AgentGroupName" :label="Language('坐席组')"></el-table-column>
          <el-table-column prop="SkillName" :label="Language('技能')"></el-table-column>
          <el-table-column prop="CallData" :label="Language('呼叫数据')"></el-table-column>
        </el-table>
      </div>
      <div class="diglog-bom-box">
        <el-button type="primary" size="small" @click="submitHoldCallFn">{{Language('确 定')}}</el-button>
        <el-button @click="holdCallShow = false" size="small">{{Language('取 消')}}</el-button>
      </div>
    </el-dialog>

    <el-dialog title="配置信息" :visible.sync="startInfo" width="600px" :modal-append-to-body="false" custom-class="center-dialog setinfo-dialog"
     :close-on-press-escape="false" :close-on-click-modal="false" @close="closeBack('sForm')">
      <el-form :model="sForm" label-width="110px" ref="sForm" :rules="sRules" class="new-form-center" style="padding-right: 0">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="Language('分机号')" prop="extNum">
              <el-input v-model="sForm.extNum" :placeholder="Language('分机号')" size="small" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="Language('文书时长')" prop="docTimeLong">
              <el-input-number v-model="sForm.docTimeLong" size="small" :min="1" :max="9999" :step="1" step-strictly class="mr-10" :disabled="!GLOBAL.power.is_1040"></el-input-number>秒
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="Language('消息提示时长')" prop="msgTipTimeLong">
              <el-input-number v-model="sForm.msgTipTimeLong" size="small" :min="1" :max="9999" :step="1" step-strictly class="mr-10" :disabled="!GLOBAL.power.is_1042"></el-input-number>秒
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="Language('小休时长')" prop="smallRestTimeLong">
              <el-input-number v-model="sForm.smallRestTimeLong" size="small" :min="1" :max="9999" :step="1" step-strictly class="mr-10" :disabled="!GLOBAL.power.is_1041"></el-input-number>秒
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="Language('热线状态')" prop="ccState">
              <el-radio-group v-model="sForm.ccState" :disabled="!GLOBAL.power.is_1044">
                <el-radio label="32">{{Language('空闲（已签入）')}}</el-radio>
                <el-radio label="2">{{Language('示忙')}}</el-radio>
                <el-radio label="4096">{{Language('离线')}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="Language('坐席组')" prop="ccGroupData">
              <el-select v-model="sForm.ccGroupData" :placeholder="Language('坐席组')" clearable filterable multiple class="w-100bf">
                <el-option v-for="(item, index) in agentGroupData"
                  :key="index"
                  :label="item.groupName"
                  :value="item.groupId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="Language('技能组')" prop="ccSkillData">
              <el-select v-model="sForm.ccSkillData" :placeholder="Language('技能组')" clearable filterable multiple class="w-100bf">
                <el-option v-for="(item, index) in skillGroupData"
                  :key="index"
                  :label="item.skillName"
                  :value="item.skillId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="diglog-bom-box">
        <el-button type="primary" size="small" @click="loginInitUpdateDataFn" >{{Language('确 定')}}</el-button>
        <el-button @click="startInfo = false" size="small">{{Language('取 消')}}</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
import { getPublicKey, login } from "../../http/login";
import { getLinkBookMemberList } from "../../http/NoticManagement.js";
import { loginInitGetInfo, loginInitUpdateData, baseFunChkExtNum, baseFunGetDynamicPwd,
getSkillListByUserId, getGroupList, getGroupListByUserId, getAgentStatusList, getAgentListByGroupId, getIvrList, getGroupSkillList,
getSmsTemplateList, getDictList, getUserGroupAndSkillList} from "../../http/BaseData";
export default {
  data() {
    return {
      isgetUrlKey: false,
      webTimePaw: '',
      param: {
        vdnId: '',
        userId: ''
      },
      loginForm: {
        uc: '',
        pwd: '',
        vdnId: ''
      },
      agpHtmlUrl: process.env.NODE_ENV === 'development' ? window.WSSET.devAgpUrl : window.WSSET.prodAgpUrl,
      plugHtmlUrl: process.env.NODE_ENV === 'development' ? window.WSSET.devPlugUrl : window.WSSET.prodPlugUrl,
      agpBox: null, //agp工具栏容器
      plugBox: null, //工具栏配套容器
      userObj: {},
      toolbarShow: false,
      skillGroupData: [],
      agentGroupData: [],
      agentGroupDataAll: [],
      agentGroupDataOnline: [],
      skillGroupDataOnline: [],
      agentData: [],
      showAgentData: [],
      groupAndSkills: [],
      linkBookList: [],
      linkBookOne: true, //是否只能单选一个手机号
      checkPhone: '',
      checkPhoneMore: [],
      agentShow: false,
      agentDialogTitle: '坐席列表',
      page: 1,
      total: 0,
      targetGroup: null, //选中的坐席组对象
      targetAgent: null, //选中的坐席对象
      ivrPage: 1,
      ivrTotal: 0,
      ivrList: [],
      ivrShow: false,
      targetIvr: null,
      skillPage: 1,
      skillTotal: 0,
      skillList: [],
      skillShow: false,
      targetSkill: null,
      holdCallShow: false,
      holdCallList: [],
      targetHoldCall: null,
      agentGroupKey: '',
      agentKey: '',
      startInfo: false,
      sForm: {
        ccOpenFlag: '1',
        extNum: '',
        docTimeLong: 10,
        msgTipTimeLong: 10,
        smallRestTimeLong: 10,
        ccState: '32',
        ccGroupData: [],
        ccSkillData: [],
        olOpenFlag: '0',
        niceName: '',
        maxFollowQty: 1,
        isAuto: '1', //0否1是
        olState: '1',
        olGroupData: [],
        olSkillData: []
      },
      sRules: {
        ccGroupData: {required: true, message: this.Language('请选择热线坐席组')},
        ccSkillData: {required: true, message: this.Language('请选择热线技能组')}
      },
    };
  },
  name: "controlBox",
  computed: {
    linkBookShow: {
      get(){
        return this.$store.state.navTabs.linkBookShow
      },
      set(value){
        this.$store.commit("navTabs/setLinkBookShow", value);
      }
    },
  },
  created() {
    //获取传递的账号密码vdnId
    this.loginForm = {
      uc: this.$route.query.uc,
      pwd: this.$route.query.pwd,
      vdnId: this.$route.query.vdnId
    }
    this.param.vdnId = this.$route.query.vdnId

    let baseURL;
    if (process.env.NODE_ENV === 'development') {
      baseURL = window.APIURL.devUrlApi
    } else {
      baseURL = window.APIURL.prodUrlApi
    }
    LocalStorage.setItem('baseURL', baseURL)
  },
  mounted() {
    this.login()
  },
  methods: {
    // 写点击事件的方法
    async login() {
      if (!this.isgetUrlKey) {
        const res = await this.loginBefore();
        if (res.retCode == 1) {
          if (res.data.publicKey && res.data.time) {
            this.isgetUrlKey = true;//如果有密匙才加密
            LocalStorage.setItem('getPublicKey', res.data.publicKey)//存缓存，防止刷新后stroe丢失
            this.$store.commit('navTabs/setActivePublicKey', res.data.publicKey);
            this.webTimePaw = res.data.time - parseInt(new Date().getTime() / 1000);
          }
        }
      }
      if (this.isgetUrlKey) {
        let time_s = parseInt(new Date().getTime() / 1000) + this.webTimePaw;
        let obj = {
          uc: this.loginForm.uc,
          pwd: this.$encryptedData(this.$store.state.navTabs.publicKey, this.loginForm.pwd + '|' + time_s),
          vdnId: this.loginForm.vdnId,
        }
        login(obj).then(res => {
          if (res && res.retCode == 100) {
            let userObj = {
              userId: res.data.userId,
              userName: res.data.userName,
              workNo: res.data.userCode,
              vdnId: res.data.vdnId || this.loginForm.vdnId,
              authToken: res.data.authToken,
              isSystem: res.data.isSystem
            };
            this.param.userId = res.data.userId
            LocalStorage.setItem('obj', JSON.stringify(userObj));
            this.userObj = userObj

            this.plugBox = document.getElementById('plugBox')
            //调用数据接口
            this.getAgentGroupListUser(1) //热线的坐席组
            this.getSkillGroupList(1) //热线的技能组
            this.getAgentStatusListFn()
            this.getAgentGroupList()
            this.getIvrListFn(1)
            this.getGroupSkillListFn(1)
            this.getLinkBookMemberListFn()
            this.getUserGroupAndSkillListFn(()=>{
              this.loginInitGetInfoFn('start')
            })
            
          }
        });
      }
    },
    loginBefore() {
      return new Promise((resolve, reject) => {
        let data = {
          vdnId: this.loginForm.vdnId
        }
        getPublicKey(data).then(res => {
          resolve(res)
        })
      })
    },
    //获取初始化信息
    loginInitGetInfoFn(type){
      let data = {
        vdnId: this.param.vdnId,
        userId: this.param.userId
      }
      loginInitGetInfo(data).then(async res => {
        if(res){
          if (res.retCode == 1) {
            let resData = res.data
            if (resData.olGroupData.length) {
              let agentGroupDataOnline =  await this.getAgentGroupListUser(8)
              resData.olGroupData.map(item => {
                let obj = agentGroupDataOnline.filter(item2 => { return item2.groupId == item.groupId })
                item.groupName = obj.length?obj[0].groupName:''
              })
            }
            if (resData.olSkillData.length) {
              let skillGroupDataOnline = await this.getSkillGroupList(8)
              resData.olSkillData.map(item => {
                let obj = skillGroupDataOnline.filter(item2 => { return item2.skillId == item.skillId })
                item.skillName = obj.length?obj[0].skillName:''
              })
            }

            let formStr = JSON.stringify(resData)
            let form = JSON.parse(formStr)
            let oldAgentInt = LocalStorage.getItem('agentInt')
            LocalStorage.setItem('agentInt', formStr) //检查完新旧分机号后更新缓存数据
            //处理坐席组、技能组数据
            form.ccGroupData = this.returnReSet(form.ccGroupData, 'groupId')
            form.ccSkillData = this.returnReSet(form.ccSkillData, 'skillId')
            form.olGroupData = this.returnReSet(form.olGroupData, 'groupId')
            form.olSkillData = this.returnReSet(form.olSkillData, 'skillId')
            this.sForm = form //赋值到页面

            this.$set(this.userObj, 'extNum', form.extNum) //设置新分机号让子页面使用
            LocalStorage.setItem('obj', JSON.stringify(this.userObj))

            this.toolbarShow = true
            this.$nextTick(()=>{
              this.agpBox = document.getElementById('agpBox')

              if(type == 'start'){
                console.log('iframe.start')
                //初次进入需要等待子页面加载完成
                if(form.ccState != '4096'){
                  //初始化进入时，离线不连接
                  setTimeout(()=>{
                    console.log('第一次进入页面登录agp')
                    this.setAGPoneFn(form, oldAgentInt)
                  }, 2000)
                }
              }else if(type == 'edit'){
                if(form.ccState == '4096'){
                  //编辑的时候选了离线 - 已经连了agp的要退出 - 没连的不用连
                  if(this.agpBox.contentWindow.g_Socket4AGP){
                    this.setAGPoneFn(form, oldAgentInt)
                  }
                }else{
                  this.setAGPoneFn(form, oldAgentInt)
                }
              }
            })
          }
        }
      })
    },
    //交互agp - 第一步
    setAGPoneFn(form, oldAgentInt){
      //检查旧分机号与新分机号是否一致
      let reSetExnum = false //是否更改分机号
      if(oldAgentInt){
        if(JSON.parse(oldAgentInt).extNum && (JSON.parse(oldAgentInt).extNum != form.extNum)){
          //旧分机号与新分机号不相同，退出agp
          reSetExnum = true
          this.AGPoutFn()
        }
      }
      if(form.extNum){
        //有分机号，才继续连接agp
        this.setAGPtwoFn(form, reSetExnum, oldAgentInt)
      }
      this.setAGPselectDom() //设置外呼下拉框的数据
    },
    //交互agp - 第二步
    setAGPtwoFn(form, reSetExnum, oldAgentInt){
      if(reSetExnum){
        //更改分机号的情况下，需要等待agp退出后再继续
        if(this.agpBox.contentWindow.g_Socket4AGP){
          //未退出，重复检查
          setTimeout(()=>{
            this.setAGPtwoFn(form, reSetExnum, oldAgentInt)
          }, 500)
        }else{
          //已退出
          this.setAGPtwoFn(form, false, oldAgentInt)
        }
      }else{
        //正常登录agp流程
        if(form.ccState == '2' || form.ccState == '32'){
          //设置为空闲或示忙
          if(this.agpBox.contentWindow.g_Socket4AGP == null){
            this.baseFunGetDynamicPwdFn()
          }else{
            //在原agp上切换状态
            if(form.ccState != this.agpBox.contentWindow.g_iAgentStatus){
              this.agpBox.contentWindow.agentStatusSet(form.ccState)
            }
            //签出该坐席全部坐席技能组，然后重新签入
            if(oldAgentInt){
              this.agpBox.contentWindow.signOutAllGroup(JSON.parse(oldAgentInt), ()=>{
                this.agpBox.contentWindow.signInAllGroup()
              })
              this.agpBox.contentWindow.signOutAllSkill(JSON.parse(oldAgentInt), ()=>{
                this.agpBox.contentWindow.signInAllSkill()
              })
            }
          }
        }else{
          //设置为离线，退出agp
          this.AGPoutFn()
        }
      }
    },
    //退出agp
    AGPoutFn(){
      if(this.agpBox.contentWindow.g_Socket4AGP){
        this.agpBox.contentWindow.logoutFn(2) //有旧agp，退出
      }
    },
    //重构数组
    returnReSet(list, key){
      let arr = []
      if(list && list.length > 0){
        list.map((o)=>{
          arr.push(o[key])
        })
      }
      return arr
    },
    //校验分机号
    baseFunChkExtNumFn(){
      return new Promise((resolve, reject) => {
        let data = {
          vdnId: this.param.vdnId,
          userId: this.param.userId,
          extNum: this.sForm.extNum
        }
        baseFunChkExtNum(data).then(res => {
          if(res){
            if(res.retCode == 1){
              LocalStorage.setItem('extNum', this.sForm.extNum) //分机号
              resolve(true)
            }else{
              reject(false)
            }
          }
        })
      })
    },
    //获取用户技能组列表
    getSkillGroupList(type) {
      return new Promise((resolve, reject) => {
        let data = {
          vdnId: this.param.vdnId,
          userId: this.param.userId,
          mediaTypeId: type
        }
        getSkillListByUserId(data).then((res) => {
          if (res && res.retCode == 1) {
            if(type == 1){
              this.skillGroupData = res.data;
              LocalStorage.setItem('skillGroupData', JSON.stringify(this.skillGroupData))
              resolve(res.data)
            }else{
              this.skillGroupDataOnline = res.data;
              resolve(res.data)
            }
          }
        })
      })
    },
    //获取用户坐席组列表
    getAgentGroupListUser(type) {
      return new Promise((resolve, reject) => {
        let data = {
          vdnId: this.param.vdnId,
          userId: this.param.userId,
          mediaTypeId: type
        }
        getGroupListByUserId(data).then((res) => {
          if (res && res.retCode == 1) {
            if(type == 1){
              this.agentGroupData = res.data;
              LocalStorage.setItem('agentGroupData', JSON.stringify(this.agentGroupData))
              resolve(res.data)
            }else{
              this.agentGroupDataOnline = res.data;
              resolve(res.data)
            }
          }
        })
      })
    },
    //获取坐席组列表 - 全部
    getAgentGroupList() {
      let data = {
        vdnId: this.param.vdnId
      }
      getGroupList(data).then((res) => {
        if (res && res.retCode == 1) {
          this.agentGroupDataAll = res.data;
          SessionStorage.setItem('allGroupList', JSON.stringify(this.agentGroupDataAll))
        }
      })
    },
    //通讯录人员列表数据
    getLinkBookMemberListFn(){
      let data = {
        vdnId: this.param.vdnId
      }
      getLinkBookMemberList(data).then(res=>{
        if(res){
          if(res.retCode == 1){
            this.linkBookList = this.getTreeLabelFn(res.data)
          }
        }
      })
    },
    //递归处理树结构
    getTreeLabelFn(list){
      //需要先处理数据统一表示 
      for(let i = 0;i < list.length;i++){
        list[i].disabled = false
        list[i].label = list[i].name
        if(list[i].isType==1){
          this.getTreeLabelFn(list[i].children)
        }else{
          list[i].label =  list[i].label + '[' + list[i].mobileNo + ']'
        }
      }
      return list
    },
    //选择通讯录号码
    setLinkBook(){
      if(this.linkBookOne){
        //单选号码
        let node = this.checkPhone
        if(!node.mobileNo){
          this.$Msg.error('请选择有电话号码的通讯人员');
        }else{
          this.agpBox.contentWindow.phonenumSetFn(node.mobileNo, true)
          this.closeLinkBookFn()
        }
      }else{
        //多选号码
        let nodes = this.checkPhoneMore
        if(nodes.length == 0){
          this.$Msg.error('请选择通讯人员');
        }else{
          this.dynamicTags = JSON.parse(JSON.stringify(nodes))
          this.closeLinkBookFn()
        }
      }
    },
    //关闭通讯录弹窗
    closeLinkBookFn(){
      this.linkBookShow = false
      this.linkBookOne = true //默认单选
      this.$refs.tree.setCurrentKey(null)
      this.checkPhone = ''
      this.checkPhoneMore = []
      top.postMessage({thMsg: 'close'}, '*')
    },
    //打开选择接收人手机号
    openLinkBookFn(){
      this.linkBookOne = false //转为多选手机号
      this.linkBookShow = true
    },
    //获取apg热线密码
    baseFunGetDynamicPwdFn(){
      let data = {
        vdnId: this.param.vdnId
      }
      baseFunGetDynamicPwd(data).then(res => {
        if(res){
          if(res.retCode == 1){
            LocalStorage.setItem('agpPwd', res.data)
            setTimeout(()=>{
              this.agpBox.contentWindow.webSocketFn()
            }, 2000)
          }
        }
      })
    },
    //获取坐席工具栏状态列表
    getAgentStatusListFn(){
      let data = {
        vdnId: this.param.vdnId
      }
      getAgentStatusList(data).then(res => {
        if(res){
          if(res.retCode == 1){
            this.plugBox.contentWindow.setStatusListFn(res.data)
          }
        }
      })
    },
    //获取ivr列表数据
    getIvrListFn(ivrPage){
      this.ivrPage = ivrPage
      let data = {
        vdnId: this.param.vdnId,
        page: this.ivrPage,
        pageSize: 10
      }
      getIvrList(data).then((res)=>{
        if(res){
          if(res.retCode == 1){
            this.ivrList = res.data.list
            this.ivrTotal = res.data.total
          }
        }
      })
    },
    //选中坐席组查询组内坐席
    groupRowClickFn(row){
      this.targetGroup = row
      this.getAgentListByGroupIdFn(1, true)
    },
    //选中坐席
    agentRowClickFn(row){
      this.targetAgent = row
    },
    //双击坐席
    agentRowDbClickFn(row){
      this.agentRowClickFn(row)
      this.submitAgentFn()
    },
    //通过坐席组获取坐席列表
    getAgentListByGroupIdFn(page, type){
      this.page = page
      let data = {
        vdnId: this.param.vdnId,
        groupId: this.targetGroup?this.targetGroup.groupId:'',
        pageNo: page,
        pageSize: 9999
      }
      getAgentListByGroupId(data).then((res) => {
        if(res){
          if(res.retCode == 1){
            this.agentData = res.data.list
            this.showAgentData = []
            if(type){
              this.agpBox.contentWindow.agentStatusListFn(this.agentData)
            }
          }
        }
      })
    },
    //关闭坐席弹窗
    closeAgentFn(){
      this.agentData = []
      this.targetGroup = null
      this.targetAgent = null
      this.$refs.groupTable.setCurrentRow();
      this.$refs.agentTable.setCurrentRow();
      this.$store.state.navTabs.openAgentType = 0
      this.page = 1
      this.total = 0
      top.postMessage({thMsg: 'close'}, '*')
    },
    //确认选中坐席，与agp交互
    submitAgentFn(){
      if(!this.targetAgent){
        this.$Msg.error('请选择坐席')
        return false
      }
      let targetGroup = null
      if(this.targetGroup){ //左侧选择了坐席组
        targetGroup = this.targetGroup
      }else{ //左侧没选坐席组
        targetGroup = {
          groupId: this.targetAgent.groupId,
          groupName: this.targetAgent.groupName
        }
      }
      this.agpBox.contentWindow.agentEventFn(this.targetAgent, targetGroup)
      this.agentShow = false
    },
    //打开坐席列表弹窗，type 1抢接坐席，2邀请坐席，3呼叫坐席
    openAgentDialogFn(type){
      if(type == 'AgentSnatch'){
        this.agentDialogTitle = '坐席列表 (抢接坐席)'
      }else if(type == 'InviteAgent'){
        this.agentDialogTitle = '坐席列表 (邀请坐席)'
      }else if(type == 'CallAgent'){
        this.agentDialogTitle = '坐席列表 (呼叫坐席)'
      }else if(type == 'TransferAgent'){
        this.agentDialogTitle = '坐席列表 (转移至坐席)'
      }
      this.agentShow = true
      this.targetGroup = null;
      this.getAgentListByGroupIdFn(1, true)
    },
    //关闭ivr弹窗
    closeIvrFn(){
      this.targetIvr = null
      this.$store.state.navTabs.openIVR = 0
      this.$refs.ivrTable.setCurrentRow()
      top.postMessage({thMsg: 'close'}, '*')
    },
    ivrRowClickFn(row){
      this.targetIvr = row
    },
    //选择ivr
    submitIvrFn(){
      if(!this.targetIvr){
        this.$Msg.error('请选择IVR')
        return false
      }
      this.agpBox.contentWindow.ivrEventFn(this.targetIvr, '')
      this.ivrShow = false
    },
    //关闭技能弹窗
    closeSkillFn(){
      this.targetSkill = null
      this.$store.state.navTabs.openSkill = 0
      this.$refs.skillTable.setCurrentRow()
      top.postMessage({thMsg: 'close'}, '*')
    },
    skillRowClickFn(row){
      this.targetSkill = row
    },
    //选择技能组
    submitSkillFn(){
      if(!this.targetSkill){
        this.$Msg.error('请选择技能组')
        return false
      }
      this.agpBox.contentWindow.skillEventFn(this.targetSkill)
      this.skillShow = false
    },
    //获取技能组
    getGroupSkillListFn(skillPage){
      this.skillPage = skillPage
      let data = {
        vdnId: this.param.vdnId,
        pageNo: this.skillPage,
        pageSize: 10
      }
      getGroupSkillList(data).then((res)=>{
        if(res){
          if(res.retCode == 1){
            this.skillList = res.data.list
            this.skillTotal = res.data.total
          }
        }
      })
    },
    //获取当前坐席的组与技能
    getUserGroupAndSkillListFn(callback){
      let data = {
        vdnId: this.param.vdnId
      }
      getUserGroupAndSkillList(data).then((res)=>{
        if(res){
          if(res.retCode == 1){
            this.groupAndSkills = res.data
          }
        }
        if(callback){
          callback()
        }
      })
    },
    //关闭保持恢复弹窗
    closeHoldCallFn(){
      this.targetHoldCall = null
      this.$refs.holdCallTable.setCurrentRow()
      top.postMessage({thMsg: 'close'}, '*')
    },
    holdCallRowClickFn(row){
      this.targetHoldCall = row
    },
    //选择保持恢复的电话
    submitHoldCallFn(){
      if(!this.targetHoldCall){
        this.$Msg.error('请选择待恢复的通话')
        return false
      }
      this.agpBox.contentWindow.holdCallEventFn(this.targetHoldCall)
      this.holdCallShow = false
    },
    //设置外呼需要的坐席组技能组
    setAGPselectDom(){
      let target = this.plugBox.contentWindow.$('#ddlSelectGroupAndSkill4Call')
      target.html('')
      if ((this.groupAndSkills != null) && (this.groupAndSkills.length > 0)) {
        //接口返回的是该坐席有分配的坐席组技能组，但不一定是都签入了，需要与签入的坐席技能组匹配组成结构
        let agentInt = JSON.parse(LocalStorage.getItem('agentInt'))
        let groupIds = []
        let skillIds = []
        agentInt.ccGroupData.map((o)=>{
          groupIds.push(o.groupId)
        })
        agentInt.ccSkillData.map((o)=>{
          skillIds.push(o.skillId)
        })
        this.groupAndSkills.map((item)=>{
          if(groupIds.includes(item.groupId) && skillIds.includes(item.skillId)){
            //该组坐席与技能都已签入
            let text = item.groupName + " -> " + item.skillName;
            let val = String(item.groupId) + "|" + String(item.skillId);
            target.append('<option value="' + val + '">' + text + '</option>')
          }
        })
      }
    },
    //去重加强版
    distinctPlus(arr) {
			var i, j,
				len = arr.length;
			for (i = 0; i < len; i++) {
				for (j = i + 1; j < len; j++) {
					if (arr[i].userId == arr[j].userId && arr[i].skillId == arr[j].skillId) {
						arr.splice(j, 1);
						len--;
						j--;
					}
				}
			}
			return arr;
		},
    closeBack(name) {
      top.postMessage({thMsg: 'close'}, '*')
      //关闭弹窗之后需要重置那些验证
      this.$refs[name].resetFields();
    },
    //更新初始化信息
    loginInitUpdateDataFn(){
      let data = {
        vdnId: this.param.vdnId,
        userId: this.param.userId,
        ccOpenFlag: this.sForm.ccOpenFlag,
        olOpenFlag: this.sForm.olOpenFlag
      }

      //热线的配置
      data.extNum = this.sForm.extNum
      data.docTimeLong = this.sForm.docTimeLong
      data.msgTipTimeLong = this.sForm.msgTipTimeLong
      data.smallRestTimeLong = this.sForm.smallRestTimeLong
      data.ccState = this.sForm.ccState
      data.ccGroupData = []
      this.sForm.ccGroupData.map((o)=>{
        if(o){
          data.ccGroupData.push({groupId: o})
        }
        
      })
      data.ccSkillData = []
      this.sForm.ccSkillData.map((o)=>{
        if(o){
          data.ccSkillData.push({skillId: o})
        }
      })

      //在线的配置 - 这里在线的配置不需要开启，直接默认传参
      data.niceName = this.sForm.niceName
      data.maxFollowQty = this.sForm.maxFollowQty
      data.isAuto = this.sForm.isAuto
      data.olState = this.sForm.olState
      data.olGroupData = []
      this.sForm.olGroupData.map((o)=>{
        if(o){
          data.olGroupData.push({groupId: o})
        }
      })
      data.olSkillData = []
      this.sForm.olSkillData.map((o)=>{
        if(o){
          data.olSkillData.push({skillId: o})
        }
      })

      this.$refs.sForm.validate(async (valid)=>{
        if(valid){
          if(this.sForm.extNum && data.ccState != 4096){
            const isGo = await this.baseFunChkExtNumFn()
            if(!isGo){
              return false
            }
          }
          this.infoUpdataFn(data)
        }
      })
    },
    //更新初始化设置接口
    infoUpdataFn(data){
      loginInitUpdateData(data).then(res => {
        if(res){
          if (res.retCode == 1) {
            this.$Msg.success('修改成功');
            this.startInfo = false;
            this.loginInitGetInfoFn('edit')
          }
        }
      })
    },
  },
  watch: {
    "$store.state.navTabs.openAgentType": {
      deep: true,
      handler(val, oldVal){
        if(val !== 0){
          this.openAgentDialogFn(val)
          //处理完后重置
          this.$nextTick(()=>{
            this.$store.state.navTabs.openAgentType = 0
          })
        }
      }
    },
    "$store.state.navTabs.openIVR": {
      deep: true,
      handler(val, oldVal){
        if(val !== 0){
          this.ivrShow = true
          //处理完后重置
          this.$nextTick(()=>{
            this.$store.state.navTabs.openIVR = 0
          })
        }
      }
    },
    "$store.state.navTabs.openSkill": {
      deep: true,
      handler(val, oldVal){
        if(val !== 0){
          this.skillShow = true
          //处理完后重置
          this.$nextTick(()=>{
            this.$store.state.navTabs.openSkill = 0
          })
        }
      }
    },
    "$store.state.navTabs.openHoldCall": {
      deep: true,
      handler(val, oldVal){
        if(val !== 0){
          this.holdCallShow = true
          //处理完后重置
          this.$nextTick(()=>{
            this.$store.state.navTabs.openHoldCall = 0
          })
        }
        this.holdCallList = this.agpBox.contentWindow.$Global.HoldCallList
      }
    },
    //当前显示的坐席列表里各坐席状态
    "$store.state.navTabs.agentStatus": {
      deep: true,
      handler(val, oldVal){
        if(val){
          this.showAgentData = []
          //把状态加入到坐席列表里
          this.agentData.map((m)=>{
            val.map((v)=>{
              if(v.AgentID && (m.userId == v.AgentID)){
                if(this.agentDialogTitle == '坐席列表 (抢接坐席)'){
                  if(v.AgentStatus == 64){
                    //振铃 - 抢接
                    m.status = 64
                    this.showAgentData.push(m)
                  }
                }else{
                  if(v.AgentStatus == 32){
                    //空闲 - 可以邀请-呼叫-转移
                    m.status = 32
                    this.showAgentData.push(m)
                  }
                }
              }
            })
          })
          // console.log("this.showAgentData")
          // console.log(this.showAgentData)
          this.showAgentData = this.distinctPlus(this.showAgentData)
          //处理完后重置
          this.$nextTick(()=>{
            this.$store.state.navTabs.agentStatus = ''
          })
        }
      }
    },
    agentGroupKey(){
      if(this.targetGroup){
        //已有选中的坐席组，筛查后要选中对应的行高亮
        this.$refs.groupTable.setCurrentRow(this.targetGroup);
      }
    },
    agentKey(){
      if(this.targetAgent){
        //已有选中的坐席，筛查后要选中对应的行高亮
        this.$refs.agentTable.setCurrentRow(this.targetAgent);
      }
    },
    "$store.state.navTabs.hlSet": {
      deep: true,
      handler(val, oldVal){
        if(val !== 0){
          this.startInfo = true
          //处理完后重置
          this.$nextTick(()=>{
            this.$store.state.navTabs.hlSet = 0
          })
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.transfer_item{
  border: #DCDFE6 1px solid;
  height: 400px;
  margin-top: 10px;
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// controlBox.vue?54c76601